module.exports = __webpack_public_path__ + "static/OG_What-we-do-d425f4e872139a21521e45615869a4e9.png";